<template lang="pug">
.future-chance
  calendar.calendar(@selectDate="selectDate", :color-type="colorType")
  .list
    .section(v-for="item in list" :key="item.id" @click="jumpToDetail(item.id,item.detail_type,item.report_type)")
      span.type(:class="item.detail_type") {{item.detail_type| tipFormat}}
      span.title.van-multi-ellipsis--l2 {{item.title}}
      vant-img.icon(:src="importantTip", width="1.71rem", height="1.71rem", v-if="item.importance === 1")
  router-view
</template>

<script>
import Calendar from './partial/calendar'
import Requests from '@utils/requests'
import { Toast, Image } from 'vant'
import importantTip from '@assets/icon/important-tip.png'

const typeArr = {
  event: '驱动事件',
  hot: '近期热点',
  marco: '宏观事件',
  'trading-tips': '交易提示',
  'investment-report': '财务报告'
}

export default {
  components: {
    Calendar,
    VantImg: Image
  },
  filters: {
    tipFormat(type) {
      return typeArr[type]
    }
  },
  data() {
    return {
      list: [],
      importantTip
    }
  },
  computed: {
    colorType() {
      return this.$store.state.colorType
    }
  },
  methods: {
    fetchList(date) {
      this.list = []
      let list = []
      return new Promise(resolve => {
        Requests({
          url: '/shudan/get_ht_calendar_list_for_api',
          method: 'post',
          params: { date }
        }).then(({ data }) => {
          if (data.data.total === 0) {
            return Toast('该日期下暂无数据')
          }
          const listData = data.data.data
          Object.entries(listData).map(item => { return item[0] }).sort().forEach(key => {
            list = list.concat(listData[key].map(item => {
              return {
                ...item,
                detail_type: key
              }
            }))
          })
          this.list = list
        })
      })
    },
    // 跳转至详情
    jumpToDetail(id, type, reportType) {
      if (type === 'trading-tips') return
      if (type === 'investment-report') {
        this.$router.push({
          name: 'ReportDetail',
          params: {
            id,
            type: reportType
          }
        })
      } else {
        this.$router.push({
          name: 'FutureChanceDetail',
          params: {
            id,
            type
          }
        })
      }
    },
    // 日期选择
    selectDate(date) {
      this.fetchList(date)
    }
  }
}
</script>

<style lang="stylus" scoped>
.future-chance
  .calendar
    margin-bottom 1rem
  .list
    height calc(100vh - 10rem)
    overflow scroll
    padding 0 1rem
    .section
      display flex
      position relative
      &:last-child
        margin 0
      .icon
        position absolute
        right 0
        top 0
      .type
        width 2.57rem
        border-radius .29rem
        font-size .86rem
        text-align center
        padding .14rem
        box-sizing border-box
      .title
        width calc(100% - 5.71rem)
        position absolute
        left 4.64rem
        top 50%
        transform translate(0,-50%)
.event
  color rgba(255,102,52,1)
  background-color rgba(255,102,52,.1)
.hot,.trading-tips,.marco
  color rgba(86,135,255,1)
  background-color rgba(86,135,255,.1)
.investment-report
  color rgba(2,198,237,1)
  background-color rgba(2,198,237,.1)
</style>
